// import {NO_DEPOSIT_FEE_RATE} from "../../../config";
import {DepositOptions} from "../../../models";
import {formatPounds} from "../../../utils/currency";
import {observe} from "../utils/scripts";

export const NO_DEPOSIT_FEE_RATE = 0.01;
export const AGENT_COMMISSION_RATE = 0.005;

type DepositParams = {
  price: number;
  deposit: DepositOptions;
};

// Duplicante of: services/DealService/utils.ts calculateDeposit()
const calculateDeposit = ({price, deposit}: DepositParams) => {
  const weekly = (price * 12) / 52;
  return Math.floor((deposit.fixed || 0) + (deposit.weeks || 0) * weekly + (deposit.months || 0) * price);
};

type NoDepositParams = {
  price: number;
  duration: number;
};

// Duplicante of: services/DealService/utils.ts calculateNoDepositFee()
const calculateNoDepositFee = ({price, duration}: NoDepositParams) => {
  const weekly = (price * 12) / 52;
  const dealValue = price * duration;
  return dealValue * NO_DEPOSIT_FEE_RATE + weekly;
};

type AgentCommissionParams = {
  price: number;
  duration: number;
};

const calculateAgentCommission = ({price, duration}: AgentCommissionParams) => {
  return price * duration * AGENT_COMMISSION_RATE;
};

export const updateNoDepositValues = (el: HTMLInputElement) => {
  const tenancyDurationEl = document.getElementById("tenancy-duration") as HTMLInputElement;
  const offerPriceEl = document.getElementById("offer-price") as HTMLInputElement;
  const holdingDepositEl = document.querySelectorAll("[data-holding-deposit]") as NodeListOf<HTMLInputElement>;
  const noDepositFeeEl = document.querySelectorAll("[data-no-deposit-fee]") as NodeListOf<HTMLInputElement>;
  const securityDepositEl = document.querySelectorAll("[data-security-deposit]") as NodeListOf<HTMLInputElement>;
  const agentCommissionEl = document.querySelectorAll("[data-agent-commission]") as NodeListOf<HTMLInputElement>;
  const securityDepositOptionsString = el.getAttribute("data-security-deposit-options");
  const holdingDepositOptionsString = el.getAttribute("data-holding-deposit-options");

  const render = () => {
    const tenancyDuration = Number.parseInt(tenancyDurationEl.value);
    const offerPrice = Number.parseInt(offerPriceEl.value);
    const securityDepositOptions = JSON.parse(securityDepositOptionsString || "{}");
    const holdingDepositOptions = JSON.parse(holdingDepositOptionsString || "{}");

    const securityDeposit = calculateDeposit({price: offerPrice, deposit: securityDepositOptions});
    const holdingDeposit = calculateDeposit({price: offerPrice, deposit: holdingDepositOptions});

    const noDepositFee = calculateNoDepositFee({price: offerPrice, duration: tenancyDuration});
    const agentCommission = calculateAgentCommission({price: offerPrice, duration: tenancyDuration});

    if (noDepositFeeEl) {
      noDepositFeeEl.forEach((e) => {
        if (noDepositFee > 10) {
          e.textContent = formatPounds(noDepositFee, "pounds");
        } else {
          e.textContent = "-";
        }
      });
    }
    if (securityDepositEl) {
      securityDepositEl.forEach((e) => {
        if (securityDeposit > 10) {
          e.textContent = formatPounds(securityDeposit, "pounds");
        } else {
          e.textContent = "-";
        }
      });
    }
    if (agentCommissionEl) {
      agentCommissionEl.forEach((e) => {
        if (agentCommission > 10) {
          e.textContent = formatPounds(agentCommission, "pounds");
        } else {
          e.textContent = "+0.5%";
        }
      });
    }
    if (holdingDepositEl) {
      holdingDepositEl.forEach((e) => {
        if (holdingDeposit > 10) {
          e.textContent = formatPounds(holdingDeposit, "pounds");
        } else {
          e.textContent = "-";
        }
      });
    }
  };

  //init values
  render();

  tenancyDurationEl.addEventListener("input", render);
  offerPriceEl.addEventListener("input", render);
};

observe("[data-security-deposit-options]", (el, added) => {
  if (added) {
    updateNoDepositValues(el as HTMLInputElement);
  }
});
